import React from 'react';
import { DatePicker, Button, Tooltip } from 'antd';
import moment from 'moment';
import { DATE_INPUT_FORMAT } from 'lib/helpers/dateFormats';

// The date half of a split date/time pair (see TimeInput for the time half and for how the
// pairing works). `todayButton` stamps today's date only -- it deliberately leaves the paired
// time field alone, because Now already fills both halves and a Today that also set a time
// would make "pick the date, then type the real time" impossible.
// Both halves are pinned to the same width so a stacked Date/Time pair lines up its boxes and
// its trailing icon button. TimeInput carries the matching constant.
const PAIR_INPUT_WIDTH = '150px';

export default ({ item, values, form, value, onChange }) => {

    const date = value ? moment(value) : null;

    const handleChange = (picked) => {
        onChange(picked);
        if(picked && item.onDatePicked) {
            item.onDatePicked(picked, form, values);
        }
    };

    return <span>
        <DatePicker style={{width: PAIR_INPUT_WIDTH, marginRight: '8px'}}
            format={item.dateFormat || DATE_INPUT_FORMAT}
            value={date}
            onChange={handleChange} />
        {item.todayButton
            ? <Tooltip title="Today">
                <Button icon="calendar" onClick={() => onChange(moment().startOf('day'))} />
              </Tooltip>
            : null}
    </span>;
};
